import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";
import { Button } from "../../../components/core/basic/Button";
import { trellisPalette } from "../../../components/custom/analytics/palettes";
import moment from "moment";
import { useLocalStorage } from "@reactuses/core";
import { Modal } from "../../../components/core/basic/Modal";

const ExtensionInfo = () => {
  const [show, setShow] = useState(true);
  const [isDismissed, setIsDismissed] = useLocalStorage("dismiss_chrome_extension_help_banner", false);
  const { t } = useTranslation(["onboarding"]);

  if (
    !localStorage.extensionSignup ||
    (localStorage.extensionSignup && isDismissed) ||
    !moment(localStorage.extensionSignup).isSame(moment(), "day")
  ) {
    return null;
  }

  return (
    <Modal
      isOpen={show}
      onOpenChange={() => {
        setShow(false);
        setIsDismissed(true);
      }}
      title={t(($) => $.onboarding["Getting Started"])}
      css={{
        maxWidth: "60vw",
      }}
    >
      <p className="my-4 w-75 mx-auto text-start">
        {t(($) => $.onboarding["You’ve connected your Amazon store with the Trellis Seller Extension."])}
      </p>
      <p className="my-4 w-75 mx-auto text-start">
        {t(
          ($) =>
            $.onboarding[
              "To get started, head over to Amazon. You’ll begin to pull information about your competitors right into your browser."
            ],
        )}
      </p>
      <p className="my-4 w-75 mx-auto text-start">
        <Trans
          t={t}
          i18nKey={($) =>
            $.onboarding[
              "<articleLink>This article</articleLink> explains more how to get the most out of the Trellis Seller Extension."
            ]
          }
          components={{
            articleLink: (
              <a
                style={{ color: trellisPalette[13], fontWeight: 500 }}
                href="https://gotrellis.com/resources/blog/trellis-chrome-extension-guide/"
                target="_blank"
                rel="noopener noreferrer"
              />
            ),
          }}
        />
      </p>
      <div className="d-flex justify-content-center py-4">
        <Button onPress={() => setIsDismissed(true)}>{t(($) => $.onboarding["Get Started"])}</Button>
      </div>
    </Modal>
  );
};

export default ExtensionInfo;
